import { rangePresets } from '@gogame/intl-ts';

export const permission = 0;
export const PERIOD_PRESETS = [
  rangePresets.YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_YEAR,
  rangePresets.LAST_180_DAYS,
  rangePresets.LAST_12_MONTHS,
];

export const FILTER_PERIOD = 'period';
export const SCREEN_NAME = 'kpi';

export const COLUMN_ID = 'id';
export const COLUMN_VISIBILITY = 'visibility';
export const COLUMN_ACTIVITY = 'activityType';
export const COLUMN_METRIC = 'metric';
export const COLUMN_TRAFFIC = 'trafficType';
export const COLUMN_GENRES = 'genres';
export const COLUMN_APPLICATIONS = 'applications';
export const COLUMN_NETWORKS = 'networks';
export const COLUMN_PLATFORMS = 'platforms';
export const COLUMN_COUNTRIES = 'countries';
export const COLUMN_REGISTRATIONS = 'botRegistrationType';
export const COLUMN_FRAUD_TYPE = 'fraudType';
export const COLUMN_MIN = 'min';
export const COLUMN_AVERAGE = 'average';
export const COLUMN_MAX = 'max';
export const COLUMN_TOTAL = 'total';

export const ACTION_EDIT = 'Edit';
export const ACTION_DUPLICATE = 'Duplicate';
export const ACTION_DELETE = 'Delete';

export const CHART_SETTINGS_TREND = 'trend';
export const CHART_SETTINGS_SERIES_SUM = 'seriesSum';
